export default __webpack_public_path__ + "static/media/snap.152b071c.jpg";